module.exports = __webpack_public_path__ + "static/media/day26_autoplay.ce75e822.gif";